import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "kc_cookie_consent";

const applyConsent = (value) => {
  const ph = typeof window !== "undefined" ? window.posthog : undefined;
  if (ph && typeof ph.opt_in_capturing === "function") {
    if (value === "all") ph.opt_in_capturing();
    else if (typeof ph.opt_out_capturing === "function") ph.opt_out_capturing();
  }
};

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (stored) {
      applyConsent(stored);
    } else {
      // Keine Entscheidung getroffen: Analyse vorerst deaktivieren.
      applyConsent("essential");
      setVisible(true);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    applyConsent(value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="fixed inset-x-0 bottom-0 z-[120] p-3 sm:p-4"
        >
          <div className="mx-auto flex max-w-4xl flex-col gap-4 rounded-2xl border border-white/10 bg-brand-surface/95 p-4 backdrop-blur-xl sm:flex-row sm:items-center sm:gap-6 sm:p-5">
            <div className="flex items-start gap-3">
              <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" />
              <p className="font-body text-xs leading-relaxed text-white/70 sm:text-sm">
                Wir verwenden Cookies, um diese Website bereitzustellen und – mit deiner Einwilligung –
                die Nutzung zu analysieren. Mehr dazu in unserer{" "}
                <Link to="/datenschutz" className="text-brand-green underline underline-offset-2 hover:text-white">
                  Datenschutzerklärung
                </Link>
                .
              </p>
            </div>
            <div className="flex shrink-0 gap-3 sm:ml-auto">
              <button
                type="button"
                onClick={() => choose("essential")}
                data-testid="cookie-decline"
                className="flex-1 whitespace-nowrap rounded-full border border-white/15 px-4 py-2.5 font-heading text-sm font-semibold text-white/80 transition-colors hover:bg-white/5 sm:flex-none"
              >
                Nur notwendige
              </button>
              <button
                type="button"
                onClick={() => choose("all")}
                data-testid="cookie-accept"
                className="flex-1 whitespace-nowrap rounded-full bg-brand-green px-5 py-2.5 font-heading text-sm font-bold uppercase tracking-wide text-brand-bg glow-green-sm transition-transform hover:scale-[1.03] sm:flex-none"
              >
                Alle akzeptieren
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
